import { createStrictContext } from '../utils';
export const [AppProvider, useApp] = createStrictContext();
